const STATUS_RESPONSE = {
  error: 'error',
  success: 'success',
}

export default STATUS_RESPONSE
